/**
 * Check if can cancel a session
 * @param arg ms from epoch
 */

export default function canCancelSession(arg: number) {
  return arg > +new Date();
}
